import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
          <div>
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              desc="关于来源、立场与更新节奏，我们把最常被问到的问题都放在了这里。"
            />
            <div className="mt-8 rounded-lg border border-background-200/70 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-question-answer-line text-xl" />
              </span>
              <h3 className="font-heading mt-4 text-base font-bold text-foreground-950">还有别的疑问？</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                直接写信给我们，工作日 24 小时内回复，比在评论区提问更快。
              </p>
              <a
                href="#subscribe"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600"
              >
                前往订阅与联系
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.question}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200/70 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                    aria-expanded={isOpen}
                  >
                    <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {faq.question}
                    </h3>
                    <i
                      className={`flex-shrink-0 text-lg transition-transform ${
                        isOpen ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}